// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `v-input-textarea {
  align-items: stretch;
}
v-input-textarea .v-component-container {
  width: fit-content;
}
v-input-textarea textarea {
  border: var(--input-textarea-border) !important;
  border-radius: var(--input-textarea-border-radius) !important;
  background: var(--input-textarea-background) !important;
  box-shadow: none !important;
  font-size: var(--input-textarea-font-size) !important;
  color: var(--input-textarea-color) !important;
  min-height: var(--input-textarea-min-height);
}
v-input-textarea textarea:focus {
  box-shadow: var(--input-textarea-box-shadow) !important;
}
v-input-textarea textarea:hover {
  border-color: var(--input-textarea-border-hover-color) !important;
}
v-input-textarea .length {
  position: absolute;
  top: var(--input-textarea-top);
  right: var(--input-textarea-right);
  font-size: var(--input-textarea-font-size-length);
  color: var(--input-textarea-color-length);
}
v-input-textarea .size-small textarea {
  width: var(--input-textarea-width-small) !important;
}
v-input-textarea .size-medium textarea {
  width: var(--input-textarea-width-medium) !important;
}
v-input-textarea .size-large textarea {
  width: var(--input-textarea-width-large) !important;
}
v-input-textarea .size-full textarea {
  width: var(--input-textarea-width-full) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/input-textarea/input-textarea.component.sass"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ;AAAI;EACI,kBAAA;AAER;AAAI;EACI,+CAAA;EACA,6DAAA;EACA,uDAAA;EACA,2BAAA;EACA,qDAAA;EACA,6CAAA;EACA,4CAAA;AAER;AADQ;EACI,uDAAA;AAGZ;AAFQ;EACI,iEAAA;AAIZ;AAFI;EACI,kBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iDAAA;EACA,yCAAA;AAIR;AADQ;EACI,mDAAA;AAGZ;AAFQ;EACI,oDAAA;AAIZ;AAHQ;EACI,mDAAA;AAKZ;AAJQ;EACI,kDAAA;AAMZ","sourcesContent":["v-input-textarea\n    align-items: stretch\n    .v-component-container\n        width: fit-content\n\n    textarea\n        border: var(--input-textarea-border) !important\n        border-radius: var(--input-textarea-border-radius) !important\n        background: var(--input-textarea-background) !important\n        box-shadow: none !important\n        font-size: var(--input-textarea-font-size) !important\n        color: var(--input-textarea-color) !important\n        min-height: var(--input-textarea-min-height)\n        &:focus\n            box-shadow: var(--input-textarea-box-shadow) !important\n        &:hover\n            border-color: var(--input-textarea-border-hover-color) !important\n        \n    .length\n        position: absolute\n        top: var(--input-textarea-top)\n        right: var(--input-textarea-right)\n        font-size: var(--input-textarea-font-size-length)\n        color: var(--input-textarea-color-length)\n\n    .size-\n        &small textarea\n            width: var(--input-textarea-width-small) !important\n        &medium textarea\n            width: var(--input-textarea-width-medium) !important\n        &large textarea\n            width: var(--input-textarea-width-large) !important\n        &full textarea\n            width: var(--input-textarea-width-full) !important"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
